if (!Date.prototype.getDayRange) {
    Date.prototype.getDayRange = function () {
        return {
            start: this.getStartOfDay(),
            end: this.getEndOfDay()
        }
    }
}

if (!Date.prototype.getWeekRange) {
    Date.prototype.getWeekRange = function () {
        var currentDay = this.getDay()
        var end = this.addDays(6 - currentDay)
        return {
            start: end.addDays(-6).getStartOfDay(),
            end: end.getEndOfDay()
        }
    }
}

if (!Date.prototype.getWorkWeekRange) {
    Date.prototype.getWorkWeekRange = function () {
        var normalWeek = this.getWeekRange()
        return {
            start: normalWeek.start.addDays(1),
            end: normalWeek.end.addDays(1)
        }
    }
}

if (!Date.prototype.getMonthRange) {
    Date.prototype.getMonthRange = function () {
        return {
            start: this.getFirstDayOfMonth().getStartOfDay(),
            end: this.getLastDayOfMonth().getEndOfDay()
        }
    }
}

if (!Date.prototype.getYearRange) {
    Date.prototype.getYearRange = function () {
        var start = new Date(this.getFullYear())
        var end = start.addYears(1).addMilliseconds(-1)
        return {
            start,
            end
        }
    }
}

if (!Date.prototype.getFiscalYearRange) {
    Date.prototype.getFiscalYearRange = function () {
        var start = new Date(this.getFullYear(), 6)

        if (this.getMonth() < 6) {
            start = start.addYears(-1)
        }

        return {
            start,
            end: start.addYears(1).addMilliseconds(-1)
        }
    }
}
